import React from "react";
import {
  Sofa,
  Armchair,
  Bed,
  Table,
  Lamp,
  Blinds,
  MoreHorizontal,
  Monitor,
} from "lucide-react";

export const SofaIcon: React.FC = () => {
  return (
    <div className="flex items-center justify-center w-16 h-16 bg-indigo-100 rounded-md">
      <Sofa size={36} className="text-indigo-600" strokeWidth={1.5} />
    </div>
  );
};

export const ChairIcon: React.FC = () => {
  return (
    <div className="flex items-center justify-center w-16 h-16 bg-indigo-100 rounded-md">
      <Armchair size={36} className="text-indigo-600" strokeWidth={1.5} />
    </div>
  );
};

export const BedIcon: React.FC = () => {
  return (
    <div className="flex items-center justify-center w-16 h-16 bg-indigo-100 rounded-md">
      <Bed size={36} className="text-indigo-600" strokeWidth={1.5} />
    </div>
  );
};

export const TableIcon: React.FC = () => {
  return (
    <div className="flex items-center justify-center w-16 h-16 bg-indigo-100 rounded-md">
      <Monitor size={36} className="text-indigo-600" strokeWidth={1.5} />
    </div>
  );
};

export const LightsIcon: React.FC = () => {
  return (
    <div className="flex items-center justify-center w-16 h-16 bg-indigo-100 rounded-md">
      <Lamp size={36} className="text-indigo-600" strokeWidth={1.5} />
    </div>
  );
};

export const FabricsIcon: React.FC = () => {
  return (
    <div className="flex items-center justify-center w-16 h-16 bg-indigo-100 rounded-md">
      <Blinds size={36} className="text-indigo-600" strokeWidth={1.5} />
    </div>
  );
};

export const OtherIcon: React.FC = () => {
  return (
    <div className="flex items-center justify-center w-16 h-16 bg-indigo-100 rounded-md">
      <MoreHorizontal size={36} className="text-indigo-600" strokeWidth={1.5} />
    </div>
  );
};
